/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet, contentBlocksToText } from 'polaris-coreweb/exports';
import { getPaginatedTitle } from './getPaginatedTitle';

const getHelmetForIndexTemplate = (props) => {
  const {
    layoutData: {
      page: {
        teaser,
      },
    },
    metaData: {
      pageTitle: metaTitle,
      pageDescription: metaDescription,
    },
    pagination: {
      page: currentPage,
    },
  } = props;

  const description = contentBlocksToText(teaser) || metaDescription;

  return (
    <Helmet>
      <title>{getPaginatedTitle(metaTitle, currentPage)}</title>
      <meta property="twitter:description" content={description} />
      <meta property="og:description" content={description} />
    </Helmet>
  );
};

// @todo don't use PropTypes.array. Disable eslint for now.
/* eslint-disable react/forbid-prop-types */
getHelmetForIndexTemplate.propTypes = {
  layoutData: PropTypes.shape({
    page: PropTypes.shape({
      teaser: PropTypes.array,
    }),
  }).isRequired,
  metaData: PropTypes.shape({
    pageTitle: PropTypes.string,
    pageDescription: PropTypes.string,
  }).isRequired,
  pagination: PropTypes.shape({
    page: PropTypes.number,
  }).isRequired,
};

export default getHelmetForIndexTemplate;
